@if (useExperimentalFocus) {
    <div (mouseenter)="showEditor = true" (mouseleave)="showEditor = false">
        @if (isFocused || showEditor) {
            <sp-editor
                [content]="content"
                [baseHref]="baseHref"
                [inline]="inline"
                [toolbarMenu]="toolbarMenu"
                [containerId]="containerId"
                [placeholder]="placeholder"
                [changeContentOnKeyUp]="changeContentOnKeyUp"
                [isPasteAsText]="isPasteAsText"
                [selectedThemeColors]="selectedThemeColors()"
                [selectedDeviceMode]="selectedDeviceMode$ | async"
                [useExperimentalDblClickFocus]="useExperimentalDblClickFocus"
                (changeContent)="changeHandler($event)"
                (focusOutEvent)="focusOutEvent.emit($event)"
                (focusOutWithoutContentEvent)="focusOutWithoutContentEventHandler()"
                (showTextGradientModal)="showTextGradientModalHandler($event)"
                (showAiModal)="showAiModalHandler($event)"
                (focusInEvent)="focusInEventHandler()"
                (isEmptyContent)="isEmptyContent.emit($event)"
                (changeEditorHeight)="changeEditorHeight.emit($event)"
                [style]="{ height: 'inherit', display: 'block' }"
                (editWidgetEvent)="editWidgetHandler()"
                (editWidgetInNavigationEvent)="editWidgetInNavigationHandler()"
            />
        } @else {
            <div [innerHTML]="content | spSafeHtml"></div>
        }
    </div>
} @else {
    <sp-editor
        [content]="content"
        [baseHref]="baseHref"
        [inline]="inline"
        [toolbarMenu]="toolbarMenu"
        [containerId]="containerId"
        [placeholder]="placeholder"
        [changeContentOnKeyUp]="changeContentOnKeyUp"
        [isPasteAsText]="isPasteAsText"
        [selectedThemeColors]="selectedThemeColors()"
        [selectedDeviceMode]="selectedDeviceMode$ | async"
        [useExperimentalDblClickFocus]="useExperimentalDblClickFocus"
        (changeContent)="changeHandler($event)"
        (focusOutEvent)="focusOutEvent.emit($event)"
        (focusInEvent)="focusInEvent.emit($event)"
        (isEmptyContent)="isEmptyContent.emit($event)"
        (changeEditorHeight)="changeEditorHeight.emit($event)"
        [style]="{ height: 'inherit', display: 'block' }"
        (editWidgetEvent)="editWidgetHandler()"
    />
}
